<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <select type="text"
            @change="updateValue($event.target.value)"
            :name="name"
            :required="required"
            :disabled="disabled"
            class="form-control"
            autocomplete="address-level1"
    >
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-if="states"
              v-for="state in states"
              :value="state.id"
              :selected="value == state.id"
      >
        {{ state.initials }}
      </option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputStates',
    props: ['name', 'value', 'required', 'label', 'error'],
    data () {
      return {
        placeholder: '- -'
      }
    },
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    },
    asyncComputed: {
      states: {
        get () {
          this.placeholder = 'Carregando...'
          return this.$http.get('states?country_id=1')
          .then((response) => {
            this.placeholder = 'Selecione'
            return response.data.data
          }, () => false)
        },
        default: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputStates.vue?2411ee74